import {IconSizeProps} from "./types";

export default function EVMLightIcon({ size=40,...props}: IconSizeProps) {
    return <svg width={size} height={size} {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5955 14.6424L25.0597 7.49951L29.524 14.6424H20.5955Z" fill="#D9D9D9"/>
        <path d="M11.6667 14.6424L16.131 7.49951L20.5953 14.6424H11.6667Z" fill="#EFEFEF"/>
        <path d="M25.0596 7.50021L20.5953 14.6431L16.131 7.50021H25.0596Z" fill="white"/>
        <path d="M20.5955 14.6423L16.1312 21.7852L11.6669 14.6423H20.5955Z" fill="white"/>
        <path d="M20.595 25.3567L16.1307 32.4995L11.6664 25.3567H20.595Z" fill="#D9D9D9"/>
        <path d="M29.5242 25.3567L25.0599 32.4995L20.5956 25.3567H29.5242Z" fill="#EFEFEF"/>
        <path d="M16.1313 32.5008L20.5956 25.3579L25.0599 32.5008H16.1313Z" fill="white"/>
        <path d="M20.5955 25.3572L25.0597 18.2144L29.524 25.3572H20.5955Z" fill="white"/>
    </svg>

}